<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createOpendriveConfig } from "./fs";
  import { makeFileSystemOpendrive, opendriveLogin } from "./fs-opendrive";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createOpendriveConfig());
  let password = $state("");
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.username.trim() != "" && password != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("logging in to OpenDrive");
    try {
      config.username = config.username.trim();
      config.sessionID = await opendriveLogin(config.username, password);
      config.name = config.name.trim() || config.username;
      let fs = makeFileSystemOpendrive(config);
      telegramNotify(`New OpenDrive connection for ${config.username}`);
      captureEvent("opendrive-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect OpenDrive">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-opendrive-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-opendrive-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-opendrive-username">Username:</label>
      <input
        type="text"
        id="input-opendrive-username"
        autocomplete="username"
        class="outline-hidden border px-2 py-1"
        bind:value={config.username}
      />

      <label class="mt-3" for="input-opendrive-password">Password:</label>
      <input
        type="password"
        id="input-opendrive-password"
        autocomplete="current-password"
        class="outline-hidden border px-2 py-1"
        bind:value={password}
      />

      <div class="mt-3 w-72 text-gray-500">
        The password goes only to OpenDrive. Sumatra File Manager Online keeps the session id.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect OpenDrive</button>
    </div>
  {/snippet}
</DialogBase>
